import { render, staticRenderFns } from "./CoozzyFormCheckbox.vue?vue&type=template&id=634532c8&scoped=true"
import script from "./CoozzyFormCheckbox.vue?vue&type=script&lang=js"
export * from "./CoozzyFormCheckbox.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFormCheckbox.vue?vue&type=style&index=0&id=634532c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634532c8",
  null
  
)

export default component.exports